export enum StatsCardsTypes {
  AGG_PROGRAMME_BY_SECTOR = 'AGG_PROGRAMME_BY_SECTOR',
  // MY_AGG_PROGRAMME_BY_SECTOR = "MY_AGG_PROGRAMME_BY_SECTOR",
  AGG_NDC_ACTION_BY_TYPE = 'AGG_NDC_ACTION_BY_TYPE',
  // MY_AGG_NDC_ACTION_BY_TYPE = "MY_AGG_NDC_ACTION_BY_TYPE",
  AGG_NDC_ACTION_BY_SECTOR = 'AGG_NDC_ACTION_BY_SECTOR',
  // MY_AGG_NDC_ACTION_BY_SECTOR = "MY_AGG_NDC_ACTION_BY_SECTOR",
  TOTAL_EMISSIONS = 'TOTAL_EMISSIONS',
  // MY_TOTAL_EMISSIONS = "MY_TOTAL_EMISSIONS",
  PROGRAMME_LOCATION = 'PROGRAMME_LOCATION',
  // MY_PROGRAMME_LOCATION = "MY_PROGRAMME_LOCATION",
  INVESTMENT_LOCATION = 'INVESTMENT_LOCATION',
  // MY_INVESTMENT_LOCATION = "MY_INVESTMENT_LOCATION"
  AGG_INVESTMENT_BY_TYPE = 'AGG_INVESTMENT_BY_TYPE',
  // MY_AGG_INVESTMENT_BY_TYPE = "MY_AGG_INVESTMENT_BY_TYPE",
}
